import { EligibilityCandidate } from '@kp/eligibility/eligibility-candidate.model';
import { Deserializable, JsonObject, Serializable, Theme } from '@ktypes/models';

export class SharingValidation implements Serializable<JsonObject>, Deserializable<any, SharingValidation> {
  constructor(
    public id?: string,
    public token?: string,
    public tokenType?: string,
    public groupId?: string,
    public groupCode?: string,
    public hasEligibilityFile?: boolean,
    public needsVerification?: boolean,
    public eligibilityCandidate?: EligibilityCandidate,
    public login?: string,
    public organizationName?: string,
    public theme?: Theme
  ) {}

  serialize(): JsonObject {
    const json: JsonObject = {};
    json['id'] = this.id;
    json['token'] = this.token;
    json['tokenType'] = this.tokenType;
    json['groupId'] = this.groupId;
    json['groupCode'] = this.groupCode;
    json['hasEligibilityFile'] = this.hasEligibilityFile;
    json['needsVerification'] = this.needsVerification;
    json['candidate'] = this.eligibilityCandidate;
    json['login'] = this.login;
    json['organizationName'] = this.organizationName;
    json['theme'] = this.theme;

    return json;
  }

  deserialize(input: any): SharingValidation {
    if (input == null) {
      return null;
    }
    this.id = input.id;
    this.token = input.token;
    this.tokenType = input.tokenType;
    this.groupId = input.groupId;
    this.groupCode = input.groupCode;
    this.hasEligibilityFile = input.hasEligibilityFile;
    this.needsVerification = input.needsVerification;
    this.eligibilityCandidate = new EligibilityCandidate().deserialize(input.candidate);
    this.login = input.login;
    this.organizationName = input.organizationName;
    this.theme = new Theme().deserialize(input.theme);

    return this;
  }
}
